import { useState, type FormEvent } from 'react'
import { Link } from '@tanstack/react-router'
import { useAuth } from './useAuth'

export function ForgotPasswordPage() {
  const { isConfigured, requestPasswordReset } = useAuth()
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [pending, setPending] = useState(false)
  const [sent, setSent] = useState(false)
  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault(); setError(''); setPending(true)
    try { await requestPasswordReset(email.trim()); setSent(true) }
    catch (cause) { setError(cause instanceof Error ? cause.message : 'Unable to send the recovery email.') }
    finally { setPending(false) }
  }
  return <main className="auth-page"><section className="auth-card" aria-labelledby="recovery-title">
    <Link to="/" className="brand auth-brand"><span className="brand-mark">PR</span><span>PropertyReady</span></Link>
    <p className="eyebrow">Account recovery</p><h1 id="recovery-title">Reset your password</h1>
    {sent ? <><div className="form-success" role="status"><strong>Check your inbox</strong><span>If an account exists for {email}, we sent a secure recovery link.</span></div><Link className="button-link auth-wide-action" to="/sign-in">Return to sign in</Link></> : <><p>Enter your account email and we will send a time-limited recovery link.</p><form onSubmit={event => void submit(event)}><label htmlFor="recoveryEmail">Email</label><input id="recoveryEmail" type="email" autoComplete="email" required value={email} onChange={event => setEmail(event.target.value)} />{error && <div className="form-error" role="alert">{error}</div>}<button disabled={!isConfigured || pending}>{pending ? 'Sending…' : 'Send recovery link'}</button></form><p className="auth-switch"><Link to="/sign-in">Return to sign in</Link></p></>}
  </section></main>
}
